import { mapColors } from 'app/containers/Map/slice/map-constants';
import { createGlobalStyle } from 'styled-components';

import SFProDisplayRegular from './SFProDisplay-Regular.ttf';
import SFProDisplaySemibold from './SFProDisplay-Semibold.ttf';

/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'SF';
    src: url(${SFProDisplayRegular}) format('truetype');
  }
  @font-face {
    font-family: 'SF';
    font-weight: 600;
    src: url(${SFProDisplaySemibold}) format('truetype');
  }
  @font-face {
    font-family: 'SF';
    font-weight: 500;
    src: url(${SFProDisplaySemibold}) format('truetype');
  }
  
  html,
  body {

    height: 100%;
    width: 100%;
    line-height: 1.5;
  }
  
  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-family: 'SF';
    background-color: ${p => p.theme.background};
    svg {
    vertical-align: baseline;
    }
  }

  /* body.fontLoaded {
    font-family: 'SF';
  } */
  
  p,
  label {
    line-height: 1.5em;
  }

  input, select, button {
    font-family: inherit;
    font-size: inherit;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  
  .page-header {
    background: ${p => p.theme.backgroundColor};
    border-bottom: 1px solid ${p => p.theme.borderColor};
  }
  
  .ant-btn {
    &.ant-btn-default {
      svg path {
        fill: ${p => p.theme.text}
      }
    }
  }
  .ant-table-row {
    .visible-on-row-hover {
      opacity: 0;
      transition: 0.3s opacity;
    }

    &:hover {
      .visible-on-row-hover {
        opacity: 1;
      }
    }
  }
  .marker-color {
    background-color: ${mapColors.colors.DEFAULT};
    &.marker-color-yellow {
      background-color: ${mapColors.colors.YELLOW};
    }
    &.marker-color-blue {
      background-color: ${mapColors.colors.BLUE};
    }
    &.marker-color-green {
      background-color: ${mapColors.colors.GREEN};
    }
    &.marker-color-day-break-blue {
      background-color: #002766;
    }
  }
  .ant-list-item-meta-title{
    display: -webkit-box;
    max-width: 200px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .ant-select-single.ant-select-show-arrow .ant-select-selection-item, 
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder,
  .ant-select-item-option-content
  {
    max-width: 300px
  }
  .ant-menu-item-icon {
    vertical-align: sub;
  }
`;
